/* eslint-disable max-lines */

import { IconNotebook } from '@customTypes'

import { IconActivity } from './IconActivity'
import { IconAirplay } from './IconAirplay'
import { IconAlertCircle } from './IconAlertCircle'
import { IconAlertOctagon } from './IconAlertOctagon'
import { IconAlertTriangle } from './IconAlertTriangle'
import { IconAlignCenter } from './IconAlignCenter'
import { IconAlignJustify } from './IconAlignJustify'
import { IconAlignLeft } from './IconAlignLeft'
import { IconAlignRight } from './IconAlignRight'
import { IconAnchor } from './IconAnchor'
import { IconAperture } from './IconAperture'
import { IconArrowAscending } from './IconArrowAscending'
import { IconArrowDescending } from './IconArrowDescending'
import { IconArrowDown } from './IconArrowDown'
import { IconArrowDownLeft } from './IconArrowDownLeft'
import { IconArrowDownRight } from './IconArrowDownRight'
import { IconArrowLeft } from './IconArrowLeft'
import { IconArrowRight } from './IconArrowRight'
import { IconArrowUp } from './IconArrowUp'
import { IconArrowUpLeft } from './IconArrowUpLeft'
import { IconArrowUpRight } from './IconArrowUpRight'
import { IconAtSign } from './IconAtSign'
import { IconAward } from './IconAward'
import { IconBarChart } from './IconBarChart'
import { IconBarChart2 } from './IconBarChart2'
import { IconBattery } from './IconBattery'
import { IconBatteryCharging } from './IconBatteryCharging'
import { IconBeaker } from './IconBeaker'
import { IconBell } from './IconBell'
import { IconBellOff } from './IconBellOff'
import { IconBill } from './IconBill'
import { IconBluetooth } from './IconBluetooth'
import { IconBook } from './IconBook'
import { IconBookmark } from './IconBookmark'
import { IconBox } from './IconBox'
import { IconBriefcase } from './IconBriefcase'
import { IconBurger } from './IconBurger'
import { IconCalendar } from './IconCalendar'
import { IconCamera } from './IconCamera'
import { IconCameraOff } from './IconCameraOff'
import { IconCast } from './IconCast'
import { IconCentivo } from './IconCentivo'
import { IconCheck } from './IconCheck'
import { IconCheckAlt } from './IconCheckAlt'
import { IconCheckCircle } from './IconCheckCircle'
import { IconCheckCircleUnchecked } from './IconCheckCircleUnchecked'
import { IconCheckSquare } from './IconCheckSquare'
import { IconCheckSquareUnchecked } from './IconCheckSquareUnchecked'
import { IconChevronDown } from './IconChevronDown'
import { IconChevronLeft } from './IconChevronLeft'
import { IconChevronRight } from './IconChevronRight'
import { IconChevronsDown } from './IconChevronsDown'
import { IconChevronsLeft } from './IconChevronsLeft'
import { IconChevronsRight } from './IconChevronsRight'
import { IconChevronsUp } from './IconChevronsUp'
import { IconChevronUp } from './IconChevronUp'
import { IconChrome } from './IconChrome'
import { IconCircle } from './IconCircle'
import { IconClipboard } from './IconClipboard'
import { IconClock } from './IconClock'
import { IconCloud } from './IconCloud'
import { IconCloudDrizzle } from './IconCloudDrizzle'
import { IconCloudLightning } from './IconCloudLightning'
import { IconCloudOff } from './IconCloudOff'
import { IconCloudRain } from './IconCloudRain'
import { IconCloudSnow } from './IconCloudSnow'
import { IconCommand } from './IconCommand'
import { IconCompass } from './IconCompass'
import { IconCopy } from './IconCopy'
import { IconCornerDownLeft } from './IconCornerDownLeft'
import { IconCornerDownRight } from './IconCornerDownRight'
import { IconCornerLeftDown } from './IconCornerLeftDown'
import { IconCornerLeftUp } from './IconCornerLeftUp'
import { IconCornerRightDown } from './IconCornerRightDown'
import { IconCornerRightUp } from './IconCornerRightUp'
import { IconCornerUpLeft } from './IconCornerUpLeft'
import { IconCornerUpRight } from './IconCornerUpRight'
import { IconCpu } from './IconCpu'
import { IconCreditCard } from './IconCreditCard'
import { IconCrosshair } from './IconCrosshair'
import { IconDelete } from './IconDelete'
import { IconDirectionalSort } from './IconDirectionalSort'
import { IconDisc } from './IconDisc'
import { IconDoubleArrow } from './IconDoubleArrow'
import { IconDownload } from './IconDownload'
import { IconDownloadCloud } from './IconDownloadCloud'
import { IconDroplet } from './IconDroplet'
import { IconEdit } from './IconEdit'
import { IconEdit2 } from './IconEdit2'
import { IconEdit3 } from './IconEdit3'
import { IconExport } from './IconExport'
import { IconExport2 } from './IconExport2'
import { IconExternalLink } from './IconExternalLink'
import { IconEye } from './IconEye'
import { IconEyeOff } from './IconEyeOff'
import { IconFacebook } from './IconFacebook'
import { IconFastForward } from './IconFastForward'
import { IconFax } from './IconFax'
import { IconFeather } from './IconFeather'
import { IconFile } from './IconFile'
import { IconFileMinus } from './IconFileMinus'
import { IconFilePlus } from './IconFilePlus'
import { IconFileText } from './IconFileText'
import { IconFillAlertTriangle } from './IconFillAlertTriangle'
import { IconFillCheckCircle } from './IconFillCheckCircle'
import { IconFillErrorCircle } from './IconFillErrorCircle'
import { IconFillInfoCircle } from './IconFillInfoCircle'
import { IconFilm } from './IconFilm'
import { IconFilter } from './IconFilter'
import { IconFilterList } from './IconFilterList'
import { IconFlag } from './IconFlag'
import { IconFolder } from './IconFolder'
import { IconGithub } from './IconGithub'
import { IconGlobe } from './IconGlobe'
import { IconGrid } from './IconGrid'
import { IconHash } from './IconHash'
import { IconHeadphones } from './IconHeadphones'
import { IconHeart } from './IconHeart'
import { IconHelpQuestionmark } from './IconHelpQuestionmark'
import { IconHome } from './IconHome'
import { IconIdCard } from './IconIdCard'
import { IconImage } from './IconImage'
import { IconInbox } from './IconInbox'
import { IconInfo } from './IconInfo'
import { IconInstagram } from './IconInstagram'
import { IconLayers } from './IconLayers'
import { IconLayout } from './IconLayout'
import { IconLevels } from './IconLevels'
import { IconLifeBuoy } from './IconLifeBuoy'
import { IconLink } from './IconLink'
import { IconLink2 } from './IconLink2'
import { IconList1 } from './IconList1'
import { IconList2 } from './IconList2'
import { IconList3 } from './IconList3'
import { IconLoader } from './IconLoader'
import { IconLock } from './IconLock'
import { IconLogIn } from './IconLogIn'
import { IconLogOut } from './IconLogOut'
import { IconMail } from './IconMail'
import { IconMap } from './IconMap'
import { IconMapPin } from './IconMapPin'
import { IconMaximize } from './IconMaximize'
import { IconMaximize2 } from './IconMaximize2'
import { IconMenu } from './IconMenu'
import { IconMessageCircle } from './IconMessageCircle'
import { IconMessageSquare } from './IconMessageSquare'
import { IconMic } from './IconMic'
import { IconMicOff } from './IconMicOff'
import { IconMinimize } from './IconMinimize'
import { IconMinimize2 } from './IconMinimize2'
import { IconMinus } from './IconMinus'
import { IconMinusCircle } from './IconMinusCircle'
import { IconMinusSquare } from './IconMinusSquare'
import { IconMonitor } from './IconMonitor'
import { IconMoon } from './IconMoon'
import { IconMoreHorizontal } from './IconMoreHorizontal'
import { IconMoreVertical } from './IconMoreVertical'
import { IconMove } from './IconMove'
import { IconMusic } from './IconMusic'
import { IconNavigation } from './IconNavigation'
import { IconNavigation2 } from './IconNavigation2'
import { IconOctagon } from './IconOctagon'
import { IconPackage } from './IconPackage'
import { IconPause } from './IconPause'
import { IconPauseCircle } from './IconPauseCircle'
import { IconPercent } from './IconPercent'
import { IconPhone } from './IconPhone'
import { IconPhoneCall } from './IconPhoneCall'
import { IconPhoneForwarded } from './IconPhoneForwarded'
import { IconPhoneIncoming } from './IconPhoneIncoming'
import { IconPhoneMissed } from './IconPhoneMissed'
import { IconPhoneOff } from './IconPhoneOff'
import { IconPhoneOutgoing } from './IconPhoneOutgoing'
import { IconPieChart } from './IconPieChart'
import { IconPill } from './IconPill'
import { IconPlanOfCare } from './IconPlanOfCare'
import { IconPlay } from './IconPlay'
import { IconPlayCircle } from './IconPlayCircle'
import { IconPlus } from './IconPlus'
import { IconPlusCircle } from './IconPlusCircle'
import { IconPlusSquare } from './IconPlusSquare'
import { IconPocket } from './IconPocket'
import { IconPower } from './IconPower'
import { IconPrinter } from './IconPrinter'
import { IconRadio } from './IconRadio'
import { IconReferral } from './IconReferral'
import { IconRefreshCcw } from './IconRefreshCcw'
import { IconRefreshCw } from './IconRefreshCw'
import { IconRepeat } from './IconRepeat'
import { IconRewind } from './IconRewind'
import { IconRotateCcw } from './IconRotateCcw'
import { IconRotateCw } from './IconRotateCw'
import { IconRx } from './IconRx'
import { IconSave } from './IconSave'
import { IconScissors } from './IconScissors'
import { IconSearch } from './IconSearch'
import { IconServer } from './IconServer'
import { IconSettings } from './IconSettings'
import { IconShare } from './IconShare'
import { IconShare2 } from './IconShare2'
import { IconShield } from './IconShield'
import { IconShuffle } from './IconShuffle'
import { IconSidebar } from './IconSidebar'
import { IconSkipBack } from './IconSkipBack'
import { IconSkipForward } from './IconSkipForward'
import { IconSlack } from './IconSlack'
import { IconSlash } from './IconSlash'
import { IconSliceArrowLeft } from './IconSliceArrowLeft'
import { IconSliceCancel } from './IconSliceCancel'
import { IconSliceChevronDown } from './IconSliceChevronDown'
import { IconSliceChevronUp } from './IconSliceChevronUp'
import { IconSliceCurlyArrowDown } from './IconSliceCurlyArrowDown'
import { IconSliceCurlyArrowLeft } from './IconSliceCurlyArrowLeft'
import { IconSliceDoctor } from './IconSliceDoctor'
import { IconSliceExternalLink } from './IconSliceExternalLink'
import { IconSliceFaxFill } from './IconSliceFaxFill'
import { IconSliceFillErrorDiamond } from './IconSliceFillErrorDiamond'
import { IconSliceHealth } from './IconSliceHealth'
import { IconSliceLocation } from './IconSliceLocation'
import { IconSliceMapPinFill } from './IconSliceMapPinFill'
import { IconSliceMenu } from './IconSliceMenu'
import { IconSliceMinus } from './IconSliceMinus'
import { IconSlicePhone } from './IconSlicePhone'
import { IconSlicePhoneFill } from './IconSlicePhoneFill'
import { IconSlicePlus } from './IconSlicePlus'
import { IconSliceSearch } from './IconSliceSearch'
import { IconSliceVideo } from './IconSliceVideo'
import { IconSliceVideoFill } from './IconSliceVideoFill'
import { IconSliceX } from './IconSliceX'
import { IconSliceXCircle } from './IconSliceXCircle'
import { IconSmartphone } from './IconSmartphone'
import { IconSpeaker } from './IconSpeaker'
import { IconSpeechBubble } from './IconSpeechBubble'
import { IconSquare } from './IconSquare'
import { IconStar } from './IconStar'
import { IconStethoscope } from './IconStethoscope'
import { IconStopCircle } from './IconStopCircle'
import { IconSun } from './IconSun'
import { IconSunrise } from './IconSunrise'
import { IconSunset } from './IconSunset'
import { IconTablet } from './IconTablet'
import { IconTag } from './IconTag'
import { IconTagPointRight } from './IconTagPointRight'
import { IconTarget } from './IconTarget'
import { IconThermometer } from './IconThermometer'
import { IconThumbsDown } from './IconThumbsDown'
import { IconThumbsUp } from './IconThumbsUp'
import { IconToggleLeft } from './IconToggleLeft'
import { IconToggleRight } from './IconToggleRight'
import { IconTrash } from './IconTrash'
import { IconTrash2 } from './IconTrash2'
import { IconTrendingDown } from './IconTrendingDown'
import { IconTrendingUp } from './IconTrendingUp'
import { IconTriangle } from './IconTriangle'
import { IconTwitter } from './IconTwitter'
import { IconType } from './IconType'
import { IconUmbrella } from './IconUmbrella'
import { IconUnlock } from './IconUnlock'
import { IconUpload } from './IconUpload'
import { IconUploadCloud } from './IconUploadCloud'
import { IconUser } from './IconUser'
import { IconUserCheck } from './IconUserCheck'
import { IconUserMinus } from './IconUserMinus'
import { IconUserPlus } from './IconUserPlus'
import { IconUsers } from './IconUsers'
import { IconUserX } from './IconUserX'
import { IconVideo } from './IconVideo'
import { IconVideoOff } from './IconVideoOff'
import { IconVoicemail } from './IconVoicemail'
import { IconVolume } from './IconVolume'
import { IconVolume1 } from './IconVolume1'
import { IconVolume2 } from './IconVolume2'
import { IconVolumeX } from './IconVolumeX'
import { IconWatch } from './IconWatch'
import { IconWifi } from './IconWifi'
import { IconWind } from './IconWind'
import { IconX } from './IconX'
import { IconXCircle } from './IconXCircle'
import { IconXRay } from './IconXRay'
import { IconXRayAlt } from './IconXRayAlt'
import { IconXSquare } from './IconXSquare'
import { IconZap } from './IconZap'
import { IconZoomIn } from './IconZoomIn'
import { IconZoomOut } from './IconZoomOut'

type Notebook = Record<IconNotebook, React.FC<React.ComponentPropsWithoutRef<'svg'>>>

export const notebook: Notebook = {
  'activity': IconActivity,
  'airplay': IconAirplay,
  'alert-circle': IconAlertCircle,
  'alert-octagon': IconAlertOctagon,
  'alert-triangle': IconAlertTriangle,
  'align-center': IconAlignCenter,
  'align-justify': IconAlignJustify,
  'align-left': IconAlignLeft,
  'align-right': IconAlignRight,
  'anchor': IconAnchor,
  'aperture': IconAperture,
  'arrow-ascending': IconArrowAscending,
  'arrow-descending': IconArrowDescending,
  'arrow-down-left': IconArrowDownLeft,
  'arrow-down-right': IconArrowDownRight,
  'arrow-down': IconArrowDown,
  'arrow-left': IconArrowLeft,
  'arrow-right': IconArrowRight,
  'arrow-up-left': IconArrowUpLeft,
  'arrow-up-right': IconArrowUpRight,
  'arrow-up': IconArrowUp,
  'at-sign': IconAtSign,
  'award': IconAward,
  'bar-chart-2': IconBarChart2,
  'bar-chart': IconBarChart,
  'battery-charging': IconBatteryCharging,
  'battery': IconBattery,
  'beaker': IconBeaker,
  'bell-off': IconBellOff,
  'bell': IconBell,
  'bill': IconBill,
  'bluetooth': IconBluetooth,
  'book': IconBook,
  'bookmark': IconBookmark,
  'box': IconBox,
  'briefcase': IconBriefcase,
  'burger': IconBurger,
  'calendar': IconCalendar,
  'camera-off': IconCameraOff,
  'camera': IconCamera,
  'cast': IconCast,
  'centivo': IconCentivo,
  'check-alt': IconCheckAlt,
  'check-circle-unchecked': IconCheckCircleUnchecked,
  'check-circle': IconCheckCircle,
  'check-square-unchecked': IconCheckSquareUnchecked,
  'check-square': IconCheckSquare,
  'check': IconCheck,
  'chevron-down': IconChevronDown,
  'chevron-left': IconChevronLeft,
  'chevron-right': IconChevronRight,
  'chevron-up': IconChevronUp,
  'chevrons-down': IconChevronsDown,
  'chevrons-left': IconChevronsLeft,
  'chevrons-right': IconChevronsRight,
  'chevrons-up': IconChevronsUp,
  'chrome': IconChrome,
  'circle': IconCircle,
  'clipboard': IconClipboard,
  'clock': IconClock,
  'cloud-drizzle': IconCloudDrizzle,
  'cloud-lightning': IconCloudLightning,
  'cloud-off': IconCloudOff,
  'cloud-rain': IconCloudRain,
  'cloud-snow': IconCloudSnow,
  'cloud': IconCloud,
  'command': IconCommand,
  'compass': IconCompass,
  'copy': IconCopy,
  'corner-down-left': IconCornerDownLeft,
  'corner-down-right': IconCornerDownRight,
  'corner-left-down': IconCornerLeftDown,
  'corner-left-up': IconCornerLeftUp,
  'corner-right-down': IconCornerRightDown,
  'corner-right-up': IconCornerRightUp,
  'corner-up-left': IconCornerUpLeft,
  'corner-up-right': IconCornerUpRight,
  'cpu': IconCpu,
  'credit-card': IconCreditCard,
  'crosshair': IconCrosshair,
  'delete': IconDelete,
  'directional-sort': IconDirectionalSort,
  'disc': IconDisc,
  'double-arrow': IconDoubleArrow,
  'download-cloud': IconDownloadCloud,
  'download': IconDownload,
  'droplet': IconDroplet,
  'edit-2': IconEdit2,
  'edit-3': IconEdit3,
  'edit': IconEdit,
  'export-2': IconExport2,
  'export': IconExport,
  'external-link': IconExternalLink,
  'eye-off': IconEyeOff,
  'eye': IconEye,
  'facebook': IconFacebook,
  'fast-forward': IconFastForward,
  'fax': IconFax,
  'feather': IconFeather,
  'file-minus': IconFileMinus,
  'file-plus': IconFilePlus,
  'file-text': IconFileText,
  'file': IconFile,
  'fill-alert-triangle': IconFillAlertTriangle,
  'fill-check-circle': IconFillCheckCircle,
  'fill-error-circle': IconFillErrorCircle,
  'fill-info-circle': IconFillInfoCircle,
  'film': IconFilm,
  'filter-list': IconFilterList,
  'filter': IconFilter,
  'flag': IconFlag,
  'folder': IconFolder,
  'github': IconGithub,
  'globe': IconGlobe,
  'grid': IconGrid,
  'hash': IconHash,
  'headphones': IconHeadphones,
  'heart': IconHeart,
  'help-questionmark': IconHelpQuestionmark,
  'home': IconHome,
  'id-card': IconIdCard,
  'image': IconImage,
  'inbox': IconInbox,
  'info': IconInfo,
  'instagram': IconInstagram,
  'layers': IconLayers,
  'layout': IconLayout,
  'levels': IconLevels,
  'life-buoy': IconLifeBuoy,
  'link-2': IconLink2,
  'link': IconLink,
  'list-1': IconList1,
  'list-2': IconList2,
  'list-3': IconList3,
  'loader': IconLoader,
  'lock': IconLock,
  'log-in': IconLogIn,
  'log-out': IconLogOut,
  'mail': IconMail,
  'map-pin': IconMapPin,
  'map': IconMap,
  'maximize-2': IconMaximize2,
  'maximize': IconMaximize,
  'menu': IconMenu,
  'message-circle': IconMessageCircle,
  'message-square': IconMessageSquare,
  'mic-off': IconMicOff,
  'mic': IconMic,
  'minimize-2': IconMinimize2,
  'minimize': IconMinimize,
  'minus-circle': IconMinusCircle,
  'minus-square': IconMinusSquare,
  'minus': IconMinus,
  'monitor': IconMonitor,
  'moon': IconMoon,
  'more-horizontal': IconMoreHorizontal,
  'more-vertical': IconMoreVertical,
  'move': IconMove,
  'music': IconMusic,
  'navigation-2': IconNavigation2,
  'navigation': IconNavigation,
  'octagon': IconOctagon,
  'package': IconPackage,
  'pause-circle': IconPauseCircle,
  'pause': IconPause,
  'percent': IconPercent,
  'phone-call': IconPhoneCall,
  'phone-forwarded': IconPhoneForwarded,
  'phone-incoming': IconPhoneIncoming,
  'phone-missed': IconPhoneMissed,
  'phone-off': IconPhoneOff,
  'phone-outgoing': IconPhoneOutgoing,
  'phone': IconPhone,
  'pie-chart': IconPieChart,
  'pill': IconPill,
  'plan-of-care': IconPlanOfCare,
  'play-circle': IconPlayCircle,
  'play': IconPlay,
  'plus-circle': IconPlusCircle,
  'plus-square': IconPlusSquare,
  'plus': IconPlus,
  'pocket': IconPocket,
  'power': IconPower,
  'printer': IconPrinter,
  'radio': IconRadio,
  'referral': IconReferral,
  'refresh-ccw': IconRefreshCcw,
  'refresh-cw': IconRefreshCw,
  'repeat': IconRepeat,
  'rewind': IconRewind,
  'rotate-ccw': IconRotateCcw,
  'rotate-cw': IconRotateCw,
  'rx': IconRx,
  'save': IconSave,
  'scissors': IconScissors,
  'search': IconSearch,
  'server': IconServer,
  'settings': IconSettings,
  'share-2': IconShare2,
  'share': IconShare,
  'shield': IconShield,
  'shuffle': IconShuffle,
  'sidebar': IconSidebar,
  'skip-back': IconSkipBack,
  'skip-forward': IconSkipForward,
  'slack': IconSlack,
  'slash': IconSlash,
  'slice-arrow-left': IconSliceArrowLeft,
  'slice-cancel': IconSliceCancel,
  'slice-chevron-down': IconSliceChevronDown,
  'slice-chevron-up': IconSliceChevronUp,
  'slice-curly-arrow-down': IconSliceCurlyArrowDown,
  'slice-curly-arrow-left': IconSliceCurlyArrowLeft,
  'slice-doctor': IconSliceDoctor,
  'slice-external-link': IconSliceExternalLink,
  'slice-fax-fill': IconSliceFaxFill,
  'slice-fill-error-diamond': IconSliceFillErrorDiamond,
  'slice-health': IconSliceHealth,
  'slice-location': IconSliceLocation,
  'slice-map-pin-fill': IconSliceMapPinFill,
  'slice-menu': IconSliceMenu,
  'slice-minus': IconSliceMinus,
  'slice-phone-fill': IconSlicePhoneFill,
  'slice-phone': IconSlicePhone,
  'slice-plus': IconSlicePlus,
  'slice-search': IconSliceSearch,
  'slice-video-fill': IconSliceVideoFill,
  'slice-video': IconSliceVideo,
  'slice-x-circle': IconSliceXCircle,
  'slice-x': IconSliceX,
  'smartphone': IconSmartphone,
  'speaker': IconSpeaker,
  'speech-bubble': IconSpeechBubble,
  'square': IconSquare,
  'star': IconStar,
  'stethoscope': IconStethoscope,
  'stop-circle': IconStopCircle,
  'sun': IconSun,
  'sunrise': IconSunrise,
  'sunset': IconSunset,
  'tablet': IconTablet,
  'tag-point-right': IconTagPointRight,
  'tag': IconTag,
  'target': IconTarget,
  'thermometer': IconThermometer,
  'thumbs-down': IconThumbsDown,
  'thumbs-up': IconThumbsUp,
  'toggle-left': IconToggleLeft,
  'toggle-right': IconToggleRight,
  'trash-2': IconTrash2,
  'trash': IconTrash,
  'trending-down': IconTrendingDown,
  'trending-up': IconTrendingUp,
  'triangle': IconTriangle,
  'twitter': IconTwitter,
  'type': IconType,
  'umbrella': IconUmbrella,
  'unlock': IconUnlock,
  'upload-cloud': IconUploadCloud,
  'upload': IconUpload,
  'user-check': IconUserCheck,
  'user-minus': IconUserMinus,
  'user-plus': IconUserPlus,
  'user-x': IconUserX,
  'user': IconUser,
  'users': IconUsers,
  'video-off': IconVideoOff,
  'video': IconVideo,
  'voicemail': IconVoicemail,
  'volume-1': IconVolume1,
  'volume-2': IconVolume2,
  'volume-x': IconVolumeX,
  'volume': IconVolume,
  'watch': IconWatch,
  'wifi': IconWifi,
  'wind': IconWind,
  'x-circle': IconXCircle,
  'x-ray-alt': IconXRayAlt,
  'x-ray': IconXRay,
  'x-square': IconXSquare,
  'x': IconX,
  'zap': IconZap,
  'zoom-in': IconZoomIn,
  'zoom-out': IconZoomOut,
}